import * as React from 'react';

export const TwitterWidget: React.FC<any> = ({ data }) => {
  const [url, setUrl] = React.useState(undefined);
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    document.getElementsByClassName('twitter-embed')[0].appendChild(script);
  }, []);

  React.useEffect(() => {
    const { url } = data;

    if (typeof url !== 'undefined') {
      setUrl(url);
    }
  }, [data]);
  return (
    <section className="twitterContainer">
      <div className="twitter-embed">
        <a
          className="twitter-timeline"
          data-theme="light"
          data-tweet-limit="1"
          data-chrome="noheader nofooter noborders"
          href={url}
        >
          Tweets
        </a>
      </div>
    </section>
  );
};
